import React from 'react';

// ログインは任意。誰でも使える。
export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};
